import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadAllProjects(context) {
        axios
            .get(cmsUrl + '/projects')
            .then(data => context.commit('loadAllProjectsSuccess', data.data))
            .catch(err => context.commit('loadAllProjectsError', err))
    },
    
};